module.exports = __webpack_public_path__ + "static/media/flavour-hortela.1c2214bd.png";